module.exports = {
    BUSINESS_NAME : "Theresa Products",
    BUSINESS_ADDRESS : "NO 51/17, Kalyani Mawatha, Wattala",
    BUSINESS_PHONE : "Tel: +94 77 566 0327",
    VERSION: "3.1.0"
}
